"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnforceSSL = EnforceSSL;
function EnforceSSL(url) {
  var fixedUrl = url;
  if (fixedUrl) {
    fixedUrl = fixedUrl.replace(/http:\/\//i, 'https://');
  }
  return fixedUrl;
}
//# sourceMappingURL=enforceSSL.js.map